import { useEffect, useRef } from 'react';

type ObservedSize = {
  width: number;
  height: number;
};

type useResizeObserverProps = {
  onResize: (size: ObservedSize) => void;
};

const useResizeObserver = <T extends Element>({ onResize }: useResizeObserverProps) => {
  const ref = useRef<T | null>(null);

  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const { width, height } = entry.contentRect;
        onResize({ width, height });
      }
    });
    observer.observe(ref.current!);
  }, [ref]);

  return {
    ref,
  };
};

export type { ObservedSize };
export default useResizeObserver;
